import styled from 'styled-components';
import { Grid, hideScrollbar, media } from '@simplywallst/ui-core';
import DataTable from '@/components/DataTable';
import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';

export const LoadingContainer = styled(Grid)`
  height: 100%;
`;

export const ContainerWithPlaceHolder = styled(Grid)`
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${getCloudflareImageUrl({
    src: getStaticUrl('sankey_placeholder.png'),
  })});
`;

export const TooltipContainer = styled('div')`
  width: 320px;
`;

export const SankeyWrapper = styled('div')`
  overflow-x: auto;
  ${media.mdUp`
    ${hideScrollbar}
  `}
`;

export const TooltipTable = styled(DataTable)`
  border: none;
  thead tr th {
    background: ${({ theme }) => theme.color.black};
  }
  tr {
    height: auto;
  }
  td {
    opacity: 0.7;
  }
  th,
  td {
    padding: 0;
    padding-right: ${({ theme }) => theme.x1spacePx}px;
  }
  th:last-child,
  td:last-child {
    padding-right: 0;
  }
`;
